import React, { ChangeEvent, Component } from 'react';
import { RootState } from '../../../../../redux/store';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import FormicaInput from 'components/custom/FormicaInput';
import FormicaLabel from '../../../../custom/FormicaLabel';
import { ActionState } from '../../../../../redux/reducers/ActionReducer';
import { changeAction, changeActionIsUpdate, clearAction } from '../../../../../redux/actions/ActionActions';
import { enterComponent, leaveComponent } from '../../../../../redux/actions/ComponentActions';
import { FormicaProps, withFormica } from '../../../../../helpers/withFormica';
import { ApiActionJsonModel } from '../../../../../domain/collection/rule/action/ActionDomains';
import CustomPasswordInput from '../../../../custom/CustomPasswordInput';
import { b64DecodeUnicode, b64EncodeUnicode } from '../../../../../util/Generator';
import ComponentName from '../../../../../constant/ComponentName';
import LanguageUtil from '../../../../../util/LanguageUtil';

class BasicAuthComponent extends Component<Props> {
  public state = new State();

  public render() {
    const { username, password } = this.state;
    const { disabled } = this.props;
    return (
      <div className={'w-full h-full flex flex-col items-center justify-start gap-y-2'}>
        <div className={'flex flex-col w-full gap-y-2'}>
          <FormicaLabel label={LanguageUtil.get({ id: 'common.label.username', defaultMessage: 'Username' })} />
          <FormicaInput
            disabled={disabled}
            onChange={(e: ChangeEvent<HTMLInputElement>) => this.onUsernameChange(e)}
            value={username}
            label={LanguageUtil.get({ id: 'common.label.username', defaultMessage: 'Username' })}
            data-testid={`${ComponentName.ACTION}_basic_auth_username_input`}
          />
        </div>
        <div className={'flex flex-col w-full gap-y-2 '}>
          <FormicaLabel label={LanguageUtil.get({ id: 'common.label.password', defaultMessage: 'Password' })} />
          <CustomPasswordInput
            disabled={disabled}
            onChange={(e: ChangeEvent<HTMLInputElement>) => this.onPasswordChange(e)}
            value={password}
            label={LanguageUtil.get({ id: 'common.label.password', defaultMessage: 'Password' })}
            data-testid={`${ComponentName.ACTION}_basic_auth_password_input`}
          />
        </div>
      </div>
    );
  }

  public componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
    const { base64 } = this.state;
    const {
      changeAction,
      action: { action },
    } = this.props;
    if (prevState.base64 !== base64) {
      if (!(action as ApiActionJsonModel).headers) {
        (action as ApiActionJsonModel).headers = { Authorization: '' };
      }
      (action as ApiActionJsonModel).headers['Authorization'] = 'Basic ' + base64;
      changeAction(action);
    }
  }

  public componentDidMount() {
    const {
      action: { action },
    } = this.props;
    const base64 = (action as ApiActionJsonModel).headers?.['Authorization']?.split('Basic ');
    if (base64 && base64.length > 1) {
      const decoded = b64DecodeUnicode(base64[1]);
      const [username, password] = decoded.split(':');
      this.setState({ username, password });
    }
  }

  private onUsernameChange(e: ChangeEvent<HTMLInputElement>) {
    this.setState({ username: e.currentTarget.value });
    const value = e.currentTarget.value + ':' + this.state.password;
    const encode = b64EncodeUnicode(value);
    this.setState({ base64: encode });
  }

  private onPasswordChange(e: ChangeEvent<HTMLInputElement>) {
    this.setState({ password: e.currentTarget.value });
    const value = this.state.username + ':' + e.currentTarget.value;
    const encode = b64EncodeUnicode(value);
    this.setState({ base64: encode });
  }
}

interface Props extends ReduxProps, FormicaProps {
  disabled?: boolean;
}

class State {
  username: string = '';
  password: string = '';
  base64: string = '';
}

const mapStateToProps = (state: RootState) => ({
  action: state.action as ActionState,
  isUpdate: state.action.isUpdate,
  lastCategory: state.page.lastCategory,
});
const mapDispatchToProps = {
  changeActionIsUpdate,
  changeAction,
  clearAction,
  enterComponent,
  leaveComponent,
};
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default withFormica(connector(BasicAuthComponent));
